import {
  USER_SCREENSHOT_LIST_FAIL,
  USER_SCREENSHOT_LIST_REQUEST,
  USER_SCREENSHOT_LIST_SUCCESS,
  DELETE_SCREENSHOT_FAIL,
  DELETE_SCREENSHOT_REQUEST,
  DELETE_SCREENSHOT_SUCCESS,
  UPDATE_SCREENSHOT_REASON_FAIL,
  UPDATE_SCREENSHOT_REASON_REQUEST,
  UPDATE_SCREENSHOT_REASON_SUCCESS,
  USER_DASHBOARD_SCREENSHOT_LIST_FAIL,
  USER_DASHBOARD_SCREENSHOT_LIST_REQUEST,
  USER_DASHBOARD_SCREENSHOT_LIST_SUCCESS,
} from "../../types/user/screenshot";

export const screenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_SCREENSHOT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_SCREENSHOT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        screenListsInfo: payload,
        error: "",
      };
    case USER_SCREENSHOT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        screenListsInfo: [],
      };
    default:
      return state;
  }
};

export const screenDashReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_DASHBOARD_SCREENSHOT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_DASHBOARD_SCREENSHOT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        screenListsInfo: payload,
        error: "",
      };
    case USER_DASHBOARD_SCREENSHOT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        screenListsInfo: [],
      };
    default:
      return state;
  }
};

export const updateScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_SCREENSHOT_REASON_REQUEST:
      return {
        ...state,
        updateScreenLoading: true,
      };
    case UPDATE_SCREENSHOT_REASON_SUCCESS:
      return {
        ...state,
        updateScreenLoading: false,
        updateScreenInfo: payload,
        updateScreenError: "",
      };
    case UPDATE_SCREENSHOT_REASON_FAIL:
      return {
        ...state,
        updateScreenLoading: false,
        updateScreenError: payload,
        updateScreenInfo: [],
      };
    default:
      return state;
  }
};

export const deleteScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_SCREENSHOT_REQUEST:
      return {
        ...state,
        deleteScreenLoading: true,
      };
    case DELETE_SCREENSHOT_SUCCESS:
      return {
        ...state,
        deleteScreenLoading: false,
        deleteScreenInfo: payload,
        deleteScreenError: "",
      };
    case DELETE_SCREENSHOT_FAIL:
      return {
        ...state,
        deleteScreenLoading: false,
        deleteScreenError: payload,
        deleteScreenInfo: [],
      };
    default:
      return state;
  }
};
